// src/lib/utils/match.ts

export interface MatchParams {
  mySports: string[];
  theirSports: string[];
  myLat: number;
  myLng: number;
  theirLat: number;
  theirLng: number;
  invitedBySameUser?: boolean;
  myCity?: string;
  theirCity?: string;
  mutualConnectionsCount?: number; // ← add this
}

export function calculateMatchPercentage(params: MatchParams): number {
  const normalize = (arr: string[]) =>
    arr.map(s => s.toLowerCase().trim());

  const mySports = normalize(params.mySports);
  const theirSports = normalize(params.theirSports);

  if (!mySports.length || !theirSports.length) return 80;

  const shared = mySports.filter(s => theirSports.includes(s));
  const sharedCount = shared.length;

  // Scoring weights
  const sportWeight = 20;
  const cityBonus = 25;
  const connectionBonus = 10;
  const mutualConnectionWeight = 3; // 🟢 each mutual connection gives 3 points

  const sportScore = sharedCount * sportWeight;

  const cityA = (params.myCity ?? '').toLowerCase().trim();
  const cityB = (params.theirCity ?? '').toLowerCase().trim();
  const sameCity = cityA && cityA === cityB;

  const mutualBonus = (params.mutualConnectionsCount ?? 0) * mutualConnectionWeight;

  const totalRawScore =
    sportScore +
    (sameCity ? cityBonus : 0) +
    (params.invitedBySameUser ? connectionBonus : 0) +
    mutualBonus;

  // Normalize to 80–100 range
  const MAX_RAW = 100;
  const normalizedScore = 80 + Math.min(totalRawScore, MAX_RAW) * 0.2;

  const finalScore = Math.round(Math.min(100, normalizedScore));

  // Debug output
  console.log("🟦 Match Debug:");
  console.log("  ▶ mySports:", mySports);
  console.log("  ▶ theirSports:", theirSports);
  console.log("  ▶ shared:", shared);
  console.log("  ▶ sportScore:", sportScore);
  console.log("  ▶ sameCityBonus:", sameCity ? cityBonus : 0);
  console.log("  ▶ connectionBonus:", params.invitedBySameUser ? connectionBonus : 0);
  console.log("  ▶ mutualConnectionsBonus:", mutualBonus);
  console.log("  ▶ finalScore:", finalScore);

  return finalScore;
}
